
import * as prosConnect from "./ProsConnect";

import {
    ATTR_CREATED_BY,
    ATTR_CREATED_MS_I,
    ATTR_TEXT, ATTR_UPDATED_BY, ATTR_UPDATED_MS_I,
    prosLogErr,
    STR_NO,
    STR_YES,
    VIEW_MODE_CALENDAR,
    VIEW_MODE_TABLE,
} from "./ProsConnect";
import {formatDate, PRODECT_DEFAULT_EMAIL_MSG} from "./ProsCommonUi";
import {
    CH_TAG_INCLUDE, restoreTableSettings,
} from "../containers/ProjectReportTable";
import {
    restoreMatrixSettings,
} from "../containers/ScheduleMatrix";

import {UI_OBS_TITLE, UPDATED_BY_TITLE, UPDATED_TIME_TITLE} from "../containers/ProjectReports";


function makeProjectPdfName(pdfName) {
    let withProjectName = prosConnect.getProjectInfo() + '-' + pdfName
    return withProjectName.replace(/[^a-zA-Z0-9 ()\-+]/g, '-');
}

function makeSearchObj2(project, showingSearchList) {
    if (!project) {
        return undefined
    }
    if (showingSearchList) {
        let search = project.getSelectedSearch()
        if (search) {
            return {
                searchId: project.selectedSearchId,
                name: makeProjectPdfName(search[ATTR_TEXT])
            }
        } else {
            prosLogErr("Failed to make search obj for selectedSearchId:", project.selectedSearchId)
            return undefined
        }
    }
    if (!project.selectedReports.length) {
        prosLogErr("makeSearchObj2 no reportes selected:")
        return undefined
    }
    // showing reports - make search2 obj
    let searchObj = {}
    // searchObj[ATTR_OBJ_TYPE] = OBJ_TYPE_LST_SEARCH2
    searchObj[prosConnect.ATTR_TEXT] = 'PDF-' + formatDate(Date.now());
    searchObj.name = makeProjectPdfName(searchObj[ATTR_TEXT])
    searchObj['incl_reports'] = project.selectedReports.join(';')
    // todo searchObj[ATTR_IS_PRIVATE]
    // todo searchObj[ATTR_EXPIRATION_FILTER]
    // todo select exclude not selected reports
    // console.log('project.selectedReports.length', project.selectedReports.length)
    return searchObj
}

function setSearch2Filters(project, searchObj, filters, showComments) {
    const ATTR_TEXT_FILTER_OBS = 'text_filter_obs'
    const ATTR_TEXT_FILTER_COMMMENT = 'text_filter_comm'
    for (let filter of filters) {
        if (filter.id === UI_OBS_TITLE) {
            searchObj[ATTR_TEXT_FILTER_OBS] = filter.value
            if (showComments) {
                searchObj[ATTR_TEXT_FILTER_COMMMENT] = filter.value
            }
        }
        else if (project.getChTags().indexOf(filter.id) >= 0) {
            // ON OFF selection
            searchObj['s' + filter.id] = filter.value === CH_TAG_INCLUDE ? STR_YES : STR_NO
        }
        else if (project.getRbTags().indexOf(filter.id) >= 0) {
            // Multivalue selection
            let tagValueList = []
            let tagInd = project.tagIdToIndex(filter.id)
            let rbLabels = project.getRbTagLabels(tagInd)
            for (let option of filter.value) {
                if (option === 'missing_tag_value') {
                    tagValueList.push(option)
                } else {
                    let i = rbLabels.indexOf(option)
                    if (i >= 0) {
                        tagValueList.push('' + i)
                    } else {
                        prosLogErr('Invalid tag option', filter)
                    }
                }
            }
            searchObj['s' + filter.id] = tagValueList.join(';')
        }
        else if (project.getTxtTags().indexOf(filter.id) >= 0) {
            // Free text column
            searchObj['s' + filter.id] = filter.value
        }
        else if (filter.id === 'ui_expires') {
            searchObj['flt_expire'] = filter.value.join(';')
        }
        else if (filter.id === ATTR_CREATED_MS_I) {
            searchObj['flt_' + filter.id] = filter.value.join(';')
        }
        else if (filter.id === ATTR_CREATED_BY) {
            searchObj['flt_' + filter.id] = filter.value
        }
        else if (filter.id === UPDATED_TIME_TITLE) {
            searchObj['flt_' + ATTR_UPDATED_MS_I] = filter.value.join(';')
        }
        else if (filter.id === UPDATED_BY_TITLE) {
            searchObj['flt_' + ATTR_UPDATED_BY] = filter.value
        }
        else if (filter.id === "ui_report") {
            searchObj['flt_report_name'] = filter.value
        }
        else if (filter.id === "ui_title") {
            searchObj['flt_title'] = filter.value
        }
        else if (filter.id === "ui_timeToDate") {
            searchObj['flt_remaining_time'] = filter.value.join(';')
        }
        else {
            prosLogErr('Unhandled table filter', filter)
        }
    }
}

export function sendPdfRequest(showingSearchList, reportViewMode, pdfOptions, prodectViewMode) {
    let project =  prosConnect.getActiveProject()
    let searchObj = makeSearchObj2(project, showingSearchList, pdfOptions.showComments)
    if (!searchObj) {
        return false
    }

    let uiViewSettings;
    if (reportViewMode === VIEW_MODE_CALENDAR) {
        uiViewSettings = restoreMatrixSettings(project.getPid())
        searchObj = { ...searchObj, ...uiViewSettings }
    } else if (reportViewMode === VIEW_MODE_TABLE || prodectViewMode === VIEW_MODE_TABLE) {
        uiViewSettings = restoreTableSettings(project.getPid(), 'sendPdfRequest', true)
        setSearch2Filters(project, searchObj, uiViewSettings.filters, pdfOptions.showComments)
        searchObj.hiddenCols = uiViewSettings.hiddenColumns
        searchObj.colOrder = uiViewSettings.columnOrder
        searchObj.sortOrder = uiViewSettings.sortBy
    } else { //if (reportViewMode === VIEW_MODE_LIST) {
        // In list view, we show all reports selected and show always column for reports
        searchObj.hiddenCols = [];
        searchObj.colOrder = [
           "ui_report"
        ];
    }
    
    //console.log(searchObj)
    searchObj['show_comments'] = pdfOptions.showComments ? STR_YES : STR_NO
    searchObj['show_pictures'] = pdfOptions.showPictures ? STR_YES : STR_NO

    // request PDF report
    let emailMsg = PRODECT_DEFAULT_EMAIL_MSG
    let reportId = showingSearchList ? project.selectedSearchId : 'all'
    /* ----- */
    // Start asynch operation w/o waiting request completed
    prosConnect.getActiveProject().awaitMakeWebReport(
        reportId,
        prosConnect.REPORT_TYPE_HISTORY,
        [prosConnect.getUserEmail()],
        emailMsg,
        true,
        searchObj,
        reportViewMode,
        pdfOptions);
    /* ---- */
    return true

}
